import { hydratePatients } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  CareHydratePatientsRequestT,
  CareHydratePatientsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCareHydratePatients(
  request: CareHydratePatientsRequestT,
  signal?: AbortSignal
): Promise<CareHydratePatientsResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await hydratePatients(request, config);
  return lotusHealthZod.hydratePatientsResponse.parse(
    response.data
  ) as CareHydratePatientsResponseT;
}
